import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['switch', 'handle'];

  static values = { enabled: Boolean };

  connect() {
    this.updateDisplay();
  }

  toggle() {
    this.enabledValue = !this.enabledValue;
    this.updateDisplay();
  }

  updateDisplay() {
    this.switchTarget.classList.toggle('bg-blue-surf-500', this.enabledValue); // TODO: have this be configured
    this.switchTarget.classList.toggle('bg-gray-200', !this.enabledValue);

    this.handleTarget.classList.toggle('translate-x-6', this.enabledValue);
    this.handleTarget.classList.toggle('translate-x-0', !this.enabledValue);

    this.switchTarget.setAttribute('aria-checked', this.enabledValue.toString());

    const hiddenField = this.element.querySelector('input[type=hidden]');
    hiddenField.value = this.enabledValue.toString();
  }
}
